module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('data-form', {
    attrs: {
      "entity": _vm.formModel,
      "fields": _vm.fields
    },
    on: {
      "change": _vm.onChange,
      "submit": _vm.onSubmit
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-76ae09b5!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/wifi-setting/ControllerWifiSetting.vue
// module id = 1169
// module chunks = 2